import { gsap } from 'gsap';

// 円弧テキストの無限ループ。
// startOffset を「テキスト1周分の長さ」だけ動かすと、戻った瞬間に同じ絵柄が来るので継ぎ目が出ない。
// 1周分の長さは font-size に比例するため、画面幅でフォントを変える場合は実測が必要になる。
const LOOP_DURATION = 20;
const LOOP_FALLBACK = 20; // 実測できなかったときの % （従来値）

// 実測せず -20% 固定で成立している既存ページ（TOP / topics）
const FIXED_SELECTOR = '.curved-text__item textPath, .p-homeTopic__curvedTextItem textPath';
// font-size を画面幅で変えるため実測が必要なページ
const MEASURED_SELECTOR = '.p-reportCampaign__curvedTextItem textPath';

// テキスト1周分がパス全長の何%にあたるかを返す
const loopShiftPercent = (textPath) => {
  try {
    const href = textPath.getAttribute('href') || textPath.getAttribute('xlink:href');
    const path = href ? document.querySelector(href) : null;
    if (!path) return LOOP_FALLBACK;

    const pathLength = path.getTotalLength();
    const text = textPath.textContent.replace(/\s+/g, ' ').trim();
    // 先頭12文字が次に現れる位置 ＝ 1周分の文字数
    const period = text.indexOf(text.slice(0, 12), 1);
    if (!pathLength || period <= 0) return LOOP_FALLBACK;

    // 1周分だけを同じスタイルで描いて実測する（display:none の要素では測れないので0が返る）
    const probe = textPath.parentNode.cloneNode(false);
    probe.setAttribute('visibility', 'hidden');
    probe.textContent = text.slice(0, period);
    textPath.ownerSVGElement.appendChild(probe);
    const unitLength = probe.getComputedTextLength();
    probe.remove();
    if (!unitLength) return LOOP_FALLBACK;

    return (unitLength / pathLength) * 100;
  } catch (e) {
    return LOOP_FALLBACK;
  }
};

const animeObj = {
  init() {
    gsap.to(FIXED_SELECTOR, {
      attr: { startOffset: '-20%' },
      duration: LOOP_DURATION,
      ease: 'none',
      repeat: -1
    });

    let tweens = [];
    const buildMeasuredLoop = () => {
      tweens.forEach((tween) => tween.kill());
      tweens = gsap.utils.toArray(MEASURED_SELECTOR).map((textPath) => {
        textPath.setAttribute('startOffset', '0%');
        return gsap.to(textPath, {
          attr: { startOffset: `-${loopShiftPercent(textPath)}%` },
          duration: LOOP_DURATION,
          ease: 'none',
          repeat: -1
        });
      });
    };
    buildMeasuredLoop();

    // フォントサイズが画面幅で変わるので、リサイズ後に測り直す
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildMeasuredLoop, 200);
    });
  }
}

export default animeObj;
